module.exports = __webpack_public_path__ + "img/MapPicsBigIsland.e2f2cebe.webp";